// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__33DC4","col":"CardReaderDesc_col__3FMZS","label":"CardReaderDesc_label__1arIL"};